export const DEFAULT_NAME = 'YoungCapital';

export const SITE_ABBR_MAPPING = {
  YC: 'YoungCapital',
  SJ: 'StudentJob',
  BBNL: 'Bijbaan.nl',
  PTW: 'ParttimeWerk',
  NEXT: 'YoungCapital NEXT',
  STNL: 'Stage.nl',
  BIJB: 'Bijbanen.nl',
  VWO: 'VakantieWerkOnline',
  SCW: 'ScholierenWerk',
  NJ: 'Nebenjob.de',
  FVO: 'FinancieleVacaturesOnline'
};

const startsWith = (start, text) => {
  const STARTS_WITH_REGEXP = new RegExp(`^${start}`);
  return STARTS_WITH_REGEXP.test(text);
};

export default function generateSiteName(abbr) {
  const [currentSite] = Object.keys(SITE_ABBR_MAPPING).filter(key =>
    startsWith(key, abbr)
  );
  const siteNameWithDefault = currentSite
    ? SITE_ABBR_MAPPING[currentSite]
    : DEFAULT_NAME;
  return siteNameWithDefault;
}
